import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IFileDownload, IExam, IQuestionCategory } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Router, UrlSerializer } from '@angular/router';

@Component({
  selector: 'app-question-report',
  templateUrl: './question-report.component.html',
  styleUrls: ['./question-report.component.scss']
})
export class QuestionReportComponent implements OnInit {

  category = "";
  skipImportCandidateData = false;
  questionCategories: IQuestionCategory[] = [];

  exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  exam: IExam = examDefault;
  constructor(private popoverRef: PopoverRef<QuestionReportComponent>,
    private examService: ExamService, private router: Router,
    private snackBar: SnackbarService, private serializer: UrlSerializer,) { }

  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
    }
  }

  close() {
    this.popoverRef.close();
  }

  getQuestionReport() {
    if (!this.category) {
      this.category = "NotSet"
    }
    const reportTree = this.router.createUrlTree([], { queryParams: { "examinationID": this.exam.id, "skipImportCandidateData": this.skipImportCandidateData, "category": this.category } });
    let params = this.serializer.serialize(reportTree).split('?', 2)[1];
    this.examService.getExamQuestionReport(params).then((s: IFileDownload) => {
      this.snackBar.success('Report Successfull');
      this.exportedFile = s;
      this.category = ""
    })
  }

}
